import React from "react";
import PropTypes from "prop-types";

import CheckBoxGroup from "../../atoms/checkBox/CheckBoxGroup";
import labels from "../../../config/labels";
import { NumberTransferCBU } from "../../organisms/NumberTransfer/NumberTransfer";

const NumberTransferCheckboxes = ({ checkboxes, setCheckBoxes }) => {
  const context = React.useContext(NumberTransferCBU);
  return (
    <>
      <CheckBoxGroup
        checked={checkboxes.prepaid}
        label={
          ((context?.sections || [])[2]?.items || [])[0]?.description ||
          labels.lbl_transfer_number.lbl_agree_1
        }
        onChange={(event) => {
          event.persist();
          setCheckBoxes((state) => ({
            ...state,
            prepaid: event?.target?.checked,
          }));
        }}
        id="checkbox-prepaid"
        name="checkbox-prepaid"
      />
      <CheckBoxGroup
        checked={checkboxes.new}
        label={
          ((context?.sections || [])[2]?.items || [])[1]?.description ||
          labels.lbl_transfer_number.lbl_agree_2
        }
        onChange={(event) => {
          event.persist();
          setCheckBoxes((state) => ({
            ...state,
            new: event?.target?.checked,
          }));
        }}
        id="checkbox-new"
        name="checkbox-new"
      />
      <CheckBoxGroup
        checked={checkboxes.forfeit}
        label={
          ((context?.sections || [])[2]?.items || [])[2]?.description ||
          labels.lbl_transfer_number.lbl_agree_3
        }
        onChange={(event) => {
          event.persist();
          setCheckBoxes((state) => ({
            ...state,
            forfeit: event?.target?.checked,
          }));
        }}
        id="checkbox-forfeit"
        name="checkbox-forfeit"
      />
    </>
  );
};

NumberTransferCheckboxes.propTypes = {
  checkboxes: PropTypes.object,
  setCheckBoxes: PropTypes.func,
};

export default NumberTransferCheckboxes;
